export class IconsConst {
    public static RoomsAssets: { [key: string]: string[] } = {
        notinahome: ['home'],
        home: ['home'],
        plant: ['home'],
        bedroom: ['bedroom'],
        livingroom: ['living-room'],
        dining_room: ['dining-room'],
        kitchen: ['kitchen'],
        home_office: ['desk'],
        bathroom: ['bathroom'],
        toilets: ['toilets'],
        outdoor: ['garden'],
        lobby: ['hall'],
        corridor: ['hallway'],
        custom: ['generic'],
        electrical_cabinet: ['electrical-cabinet'],
        battery_unknown: ['battery-offline color-grey large unknown', 'battery-offline-composition-overlay large unknown'],
        battery_verylow: ['battery-0 color-grey large verylow'],
        battery_low: ['battery-25 large low'],
        battery_medium: ['battery-50 large medium'],
        battery_high: ['battery-75 large good'],
        battery_full: ['battery-100 large perfect'],
        wifi_high: ['wi-fi-75 color-grey large', 'wi-fi-75-composition-overlay large good'],
        wifi_full: ['wi-fi-100 large perfect'],
        wifi_medium: ['wi-fi-50 color-grey large', 'wi-fi-50-composition-overlay large medium'],
        wifi_low: ['wi-fi-25 color-grey large', 'wi-fi-25-composition-overlay large low'],
        wifi_unknown: ['wi-fi-offline color-grey large', 'wi-fi-offline-composition-overlay large unknown'],
        signal_unknown: ['radio-offline color-grey large', 'radio-offline-composition-overlay large unknown'],
        signal_low: ['radio-25 color-grey large', 'radio-25-composition-overlay large low'],
        signal_medium: ['radio-50 color-grey large', 'radio-50-composition-overlay large medium'],
        signal_high: ['radio-75 color-grey large', 'radio-75-composition-overlay large good'],
        signal_full: ['radio-100 large perfect'],
        signal_station_unknown: ['radio-offline color-grey large', 'radio-offline-composition-overlay large unknown'],
        signal_station_low: ['radio-25 color-grey large', 'radio-25-composition-overlay large low'],
        signal_station_medium: ['radio-50 color-grey large', 'radio-50-composition-overlay large medium'],
        signal_station_high: ['radio-75 color-grey large', 'radio-75-composition-overlay large good'],
        signal_station_full: ['radio-100 large perfect'],
    };
}
